var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row py-3 m-1 mb-3 d-flex d-lg-none d-xl-none d-md-none" },
    [
      _c("div", { staticClass: "col-6 d-flex flex-column p-0" }, [
        _c("span", { staticClass: "details-label" }, [
          _vm._v("\n      Carrier\n    ")
        ]),
        _vm._v(" "),
        _vm.job.carrier
          ? _c("span", { staticClass: "details-content mb-4" }, [
              _vm._v("\n      " + _vm._s(_vm.job.carrier.name) + "\n    ")
            ])
          : _c("span", { staticClass: "details-content mb-4" }, [
              _vm._v("\n      -\n    ")
            ]),
        _vm._v(" "),
        _c("span", { staticClass: "details-label" }, [
          _vm._v("\n      Assigned to\n    ")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "details-content" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.job.cluster_user && _vm.job.cluster_user.username
                  ? _vm.job.cluster_user.username
                  : "-"
              ) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 p-0" }, [
        _c("div", { staticClass: "d-flex flex-column p-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-end movers-wrap"
            },
            [
              _c("i", {
                staticClass: "fa fa-home pr-3",
                class: _vm.job.is_small === 1 ? "icon-color" : "icon-color2"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "movers-number d-flex flex-column" }, [
                _c(
                  "div",
                  {
                    staticClass: "movers btn-status mb-1",
                    class: [
                      _vm.job.movers === _vm.job.assigned_movers.length
                        ? "turquoise-border-text"
                        : "orange-yellow-border-text",
                      _vm.job.assigned_movers.length === 0
                        ? "red-border-text"
                        : ""
                    ]
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.job.assigned_movers.length) +
                          "/" +
                          _vm._s(_vm.job.movers) +
                          "\n            "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "trucks btn-status",
                    class: [
                      _vm.job.trucks === _vm.job.assigned_trucks.length
                        ? "turquoise-border-text"
                        : "orange-yellow-border-text",
                      _vm.job.assigned_trucks.length === 0
                        ? "red-border-text"
                        : ""
                    ]
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.job.assigned_trucks.length) +
                          "/" +
                          _vm._s(_vm.job.trucks) +
                          "\n            "
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "details-label" }, [
            _vm._v("\n        Move date\n      ")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "details-content" }, [
            _vm._v("\n        " + _vm._s(_vm.job.move_date) + "\n      ")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55dc425e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55dc425e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobDetails.vue
// module id = null
// module chunks = 